//@flow
import React, {Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import {
    CardBody, CardTitle
} from 'reactstrap';
/*
type Props = {
  title: string
};*/

export default function SneakerTitle(props) {
  return(
    <CardBody className="title">
      <CardTitle tag="h4" >{props.title}</CardTitle>
    </CardBody>
  )
}
